import { render, staticRenderFns } from "./applicant-info.vue?vue&type=template&id=d816527c&scoped=true"
import script from "./applicant-info.vue?vue&type=script&lang=js"
export * from "./applicant-info.vue?vue&type=script&lang=js"
import style0 from "./applicant-info.vue?vue&type=style&index=0&id=d816527c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d816527c",
  null
  
)

export default component.exports